import { makeVar } from "@apollo/client"

const makeDashboardJobListFilters = ({ userID }) => ({
  tab: "me",
  toHasEveryone: false,
  toUsers: [userID],
  toGroups: [],
  byHasEveryone: false,
  byUsers: [],
  byGroups: [],
  hideTasks: false,
  hideProcesses: false,
  hideCompleted: false,
  hideFuture: true,
  hideHidden: true,
  sort: "jobStatus",
})

const makeJobFiltersStateVar = () => ({
  tab: "me",
  filterText: "",
  toVariant: "select",
  toOpenPickerInit: true,
  toHasEveryone: true,
  toUsers: [],
  toGroups: [],
  byVariant: "select",
  byOpenPickerInit: true,
  byHasEveryone: true,
  byUsers: [],
  byGroups: [],
  hideTasks: false,
  hideProcesses: false,
  hideCompleted: false,
  hideFuture: true,
  hideHidden: true,
  isFuture: false,
  sort: "jobStatus",
})

const jobFiltersStateVar = makeVar({
  ...makeJobFiltersStateVar(),
})

export { makeJobFiltersStateVar, makeDashboardJobListFilters, jobFiltersStateVar }
